module.exports = __webpack_public_path__ + "img/dans.2f8422b1.jpg";